//#region Libraries
import styled from "styled-components";
//#endregion

export const Container = styled.footer`
    display: flex;
    flex-direction: column;
    gap: 12px;
    width: 100%;
`;